/**
 * RFC 7807 problem `type` URIs for SMS business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Sms\Enum\SmsErrorType`.
 */
export const SmsErrorType = {
  AllRecipientsInvalidPhone: '/errors/sms-all-recipients-invalid-phone'
} as const

export type SmsErrorType = (typeof SmsErrorType)[keyof typeof SmsErrorType]
